"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteRebuildDialog = exports.SiteRebuildDialogDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var cn_1 = require("../../utils/cn");
var icon_button_1 = require("../elements/icon-button");
var dialog_1 = require("../elements/dialog");
var sprintf_js_1 = require("sprintf-js");
var cls = (0, cn_1.classNames)('site-rebuild-dialog');
var isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch"));
var icons_1 = require("../icons");
var use_lang_1 = require("../../hooks/use-lang");
var use_modal_1 = require("../../hooks/use-modal");
var markdown_1 = require("../elements/markdown");
exports.SiteRebuildDialogDefaultProps = {
  onConfirm: function () {},
  onCancel: function () {}
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var DialogStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Dialog: (0, styled_components_1.default)(dialog_1.Dialog)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), DialogStyles)
};
var SiteRebuildDialog = function (props) {
  var className = props.className,
    children = props.children,
    entity = props.entity,
    onCancel = props.onCancel,
    onConfirm = props.onConfirm;
  var t = (0, use_lang_1.useLang)();
  var modal = (0, use_modal_1.useModal)();
  var button = react_1.default.createElement(icon_button_1.IconButton, {
    onClick: function () {
      (0, isomorphic_fetch_1.default)(entity.deploymentUrl, {
        method: 'POST'
      });
      modal.hide();
      onConfirm(entity);
    },
    icon: react_1.default.createElement(icons_1.Icons.TickCircle, null)
  }, t('Confirm'));
  modal.show(react_1.default.createElement(My.Dialog, {
    title: t('Rebuild Website'),
    showCancelButton: true,
    onCancel: function () {
      modal.hide();
      onCancel(entity);
    },
    icon: icons_1.Icons.Entities.Site,
    button: button
  }, react_1.default.createElement(markdown_1.Markdown, {
    text: (0, sprintf_js_1.sprintf)(t("\n_Click Confirm_ below to _rebuild_ the website: **%s**.  \n%s\n\nThis can take up to 5 minutes, and configured administrators will be notified when this is complete.\n"), entity.name, entity.url)
  })));
  return react_1.default.createElement(My.Container, {
    className: cls.name(className)
  }, children);
};
exports.SiteRebuildDialog = SiteRebuildDialog;
exports.SiteRebuildDialog.cls = cls;
exports.SiteRebuildDialog.defaultProps = exports.SiteRebuildDialogDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;